import React, { useEffect, useMemo, useState } from "react"
import { Container, Row, Col } from "reactstrap"
import FetchProducts from "./FetchProducts"
import CustomerVehicleFlightDetails from "./CustomerVehicleFlightDetails"
import CompleteIncompleteBooking from "./completeIncompleteBooking"
import moment from "moment"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import SuccessPage from "./successBooking"
import parse from "html-react-parser"
import apiHandler from "../../common/config/apiHandler"

const AddNewBooking = () => {
  const [formData, setFormData] = useState({
    airport: "",
    dropOffDate: moment().format("YYYY-MM-DD"),
    dropOffTime: "12:00",
    pickUpDate: moment().add(7, "days").format("YYYY-MM-DD"),
    pickUpTime: "12:00",
    promoCode: "",
    website: "",
  })
  const [public_key, setPublic_key] = useState("")
  const stripePromise = loadStripe(public_key)
  const [singleProductData, setSingleProductData] = useState({})
  const [siteSubscribeKey, setSiteSubscribeKey] = useState("")
  const [selectedProduct, setSelectedProduct] = useState(null)

  const [tab, setTab] = useState("qoute")
  const [incompleteData, setIncompleteData] = useState({})
  const [userEmail, setUserEmail] = useState("")
  const [sms, setSms] = useState(0)
  const [cancellation, setCancellation] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)

  const [bookingData, setBookingData] = useState({
    title: "Mr",
    first_name: "",
    last_name: "",
    email: "",
    contact_no: "",
    departure: "",
    arrival: "",
    departure_terminal: "",
    departure_flight_no: "",
    arrival_terminal: "",
    arrival_flight_no: "",
    no_of_peoples: "",
    make: "",
    model: "",
    color: "",
    reg_no: "",
    sms_confirmation: false,
    cancellation_status: false,
  })

  const handleFormDataChange = data => {
    setFormData(prevData => ({
      ...prevData,
      ...data,
    }))
  }

  useEffect(() => {
    setTotalAmount(
      parseFloat(singleProductData?.price_before_discount) +
        parseFloat(sms ? singleProductData?.sms_charges : "0") +
        parseFloat(
          cancellation ? singleProductData?.cancellation_charges : "0"
        ) +
        parseFloat(singleProductData?.admin_charges) -
        parseFloat(singleProductData?.discount)
    )
  }, [singleProductData, sms, cancellation])

  useMemo(() => {
    ;(async () => {
      if (Object.keys(singleProductData)?.length > 0) {
        const response = await apiHandler({
          endpoint: "/backend/sites/get_stripe_key",
          method: "POST",
          options: {
            "x-access-token": localStorage.getItem("token"),
          },
          data: {
            api_tag: singleProductData?.api_tag,
            site_id: singleProductData?.site?.id,
          },
        })

        if (response.code == 200) {
          setPublic_key(response?.data?.key)
        }
      }
    })()
  }, [singleProductData])

  const getStepClass = index => {
    if (tab === "qoute" && index === 0) {
      return "active"
    } else if (tab === "customer-vehicle-flight" && index <= 1) {
      return "active"
    } else if (tab === "payment-section" && index <= 2) {
      return "active"
    } else if (tab === "success-page" && index <= 3) {
      return "active"
    }
    return ""
  }

  return (
    <Row
      style={{ padding: "0px 10px", marginTop: "180px", marginBottom: "30px" }}
    >
      <Col md={tab === "customer-vehicle-flight" || selectedProduct ? 8 : 12}>
        <Container className="add-booking py-5">
          <div className="steps-indicator d-flex justify-content-between mb-4">
            {[
              "Quote & Product",
              "Customer, Travel & Vehicle Info",
              "Payment Info",
              "Complete",
            ].map((step, index) => (
              <div key={index} className="step">
                <div className={`circle ${getStepClass(index)}`}>
                  {index + 1}
                </div>
                <span className="step-label">{step}</span>
              </div>
            ))}
          </div>

          {tab == "qoute" && (
            <FetchProducts
              onFormDataChange={handleFormDataChange}
              setTab={setTab}
              setSingleProductData={setSingleProductData}
              setSiteSubscribeKey={setSiteSubscribeKey}
              siteSubscribeKey={siteSubscribeKey}
              setFormData={setFormData}
              formData={formData}
              selectedProduct={selectedProduct}
              setSelectedProduct={setSelectedProduct}
            />
          )}

          {tab == "customer-vehicle-flight" && (
            <CustomerVehicleFlightDetails
              setTab={setTab}
              setSiteSubscribeKey={setSiteSubscribeKey}
              siteSubscribeKey={siteSubscribeKey}
              singleProductData={singleProductData}
              dateAndTime={formData}
              setIncompleteData={setIncompleteData}
              setUserEmail={setUserEmail}
              setCancellation={setCancellation}
              setSms={setSms}
              formData={bookingData}
              setFormData={setBookingData}
            />
          )}

          {tab == "payment-section" && (
            <Elements stripe={stripePromise}>
              <CompleteIncompleteBooking
                siteSubscribeKey={siteSubscribeKey}
                formData={formData}
                singleProductData={singleProductData}
                incompleteData={incompleteData}
                userEmail={userEmail}
                totalAmount={totalAmount}
                setTab={setTab}
                bookingData={bookingData}
                setBookingData={setBookingData}
              />
            </Elements>
          )}

          {tab == "success-page" && <SuccessPage />}
        </Container>
      </Col>
      {tab == "customer-vehicle-flight" && (
        <Col md={4}>
          <Container className="booking-summary py-4 px-4">
            <h5 className="summary-title mb-1">Booking Summary</h5>
            {/* <p className="summary-subtitle mb-4" style={{ fontSize: "11px" }}>
              Fill Up Booking Details To Add New Booking.
            </p> */}
            <div className="summary-details">
              <Row className="summary-item mb-3">
                <Col
                  xs="6"
                  className="summary-label text-start "
                  style={{ fontSize: "11px" }}
                >
                  Airport:
                </Col>
                <Col
                  xs="6"
                  className="summary-value text-end"
                  style={{ fontSize: "11px" }}
                >
                  {singleProductData?.airport_name}
                </Col>
              </Row>
              <Row className="summary-item mb-3">
                <Col
                  xs="6"
                  className="summary-label text-start"
                  style={{ fontSize: "11px" }}
                >
                  Drop-Off Date / Time:
                </Col>
                <Col
                  xs="6"
                  className="summary-value text-end"
                  style={{ fontSize: "11px" }}
                >
                  {`${formData.dropOffDate} ${formData.dropOffTime}`}
                </Col>
              </Row>
              <Row className="summary-item mb-3">
                <Col
                  xs="6"
                  className="summary-label text-start"
                  style={{ fontSize: "11px" }}
                >
                  Pick-Up Date / Time:
                </Col>
                <Col
                  xs="6"
                  className="summary-value text-end"
                  style={{ fontSize: "11px" }}
                >{`${formData.pickUpDate} ${formData.pickUpTime}`}</Col>
              </Row>

              <Row className="summary-item mb-3">
                <Col
                  xs="6"
                  className="summary-label text-start "
                  style={{ fontSize: "11px" }}
                >
                  Company:
                </Col>
                <Col
                  xs="6"
                  className="summary-value text-end"
                  style={{ fontSize: "11px" }}
                >
                  {singleProductData?.name}
                </Col>
              </Row>
              <Row className="summary-item mb-3" style={{ fontSize: "11px" }}>
                <Col xs="6" className="summary-label text-start">
                  Type:
                </Col>
                <Col
                  xs="6"
                  className="summary-value text-end"
                  style={{ fontSize: "11px" }}
                >
                  {singleProductData?.type}
                </Col>
              </Row>

              <Row className="summary-item mb-3">
                <Col
                  xs="6"
                  className="summary-label text-start fw-bold"
                  style={{ fontSize: "15px " }}
                >
                  Quote Price:
                </Col>
                <Col
                  xs="6"
                  className="summary-value text-end fw-bold"
                  style={{ fontSize: "15px" }}
                >
                  {singleProductData?.price_before_discount}
                </Col>
              </Row>
              <Row className="summary-item mb-3">
                <Col
                  xs="6"
                  className="summary-label text-start"
                  style={{ fontSize: "11px" }}
                >
                  SMS Confirmation:
                </Col>
                <Col
                  xs="6"
                  className="summary-value text-end"
                  style={{ fontSize: "11px" }}
                >
                  {sms ? sms : 0.0}
                </Col>
              </Row>
              <Row className="summary-item mb-3">
                <Col
                  xs="6"
                  className="summary-label text-start"
                  style={{ fontSize: "11px" }}
                >
                  Cancellation Cover:
                </Col>
                <Col
                  xs="6"
                  className="summary-value text-end"
                  style={{ fontSize: "11px" }}
                >
                  {cancellation ? cancellation : 0.0}
                </Col>
              </Row>
              <Row className="summary-item mb-3">
                <Col
                  xs="6"
                  className="summary-label text-start"
                  style={{ fontSize: "11px" }}
                >
                  Discount:
                </Col>
                <Col
                  xs="6"
                  className="summary-value text-end"
                  style={{ fontSize: "11px" }}
                >
                  -{singleProductData?.discount}
                </Col>
              </Row>
              <Row className="summary-item mb-3">
                <Col
                  xs="6"
                  className="summary-label text-start"
                  style={{ fontSize: "11px" }}
                >
                  Booking Fee:
                </Col>
                <Col
                  xs="6"
                  className="summary-value text-end"
                  style={{ fontSize: "11px" }}
                >
                  {singleProductData?.admin_charges}
                </Col>
              </Row>

              <Row className="summary-total mt-3 pt-2">
                <Col
                  xs="12"
                  className="text-center"
                  style={{ fontSize: "20px" }}
                >
                  Total Amount:{" "}
                  <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                    {(
                      parseFloat(singleProductData?.price_before_discount) +
                      parseFloat(sms) +
                      parseFloat(cancellation) +
                      parseFloat(singleProductData?.admin_charges) -
                      parseFloat(singleProductData?.discount)
                    ).toFixed(2)}
                  </span>
                </Col>
              </Row>
            </div>
          </Container>
        </Col>
      )}

      {/* For Term & COndition*/}
      {tab == "qoute" && selectedProduct && (
        <Col md={4}>
          <Container className="booking-summary py-4 px-4">
            <h5 className="summary-title mb-1">Terms & Condition</h5>
            <div className="overflow-auto" style={{ maxHeight: "250px" }}>
              {parse(selectedProduct.terms_conditions || "")}
            </div>{" "}
          </Container>
        </Col>
      )}
    </Row>
  )
}

export default AddNewBooking
